import { useEffect, useState, useCallback } from "react";
import { PopupDialog } from "../../../components/popupDialog";
import { Button } from "react-bootstrap";
import { Textbox } from "../../../components/textbox";
import { UsersController } from "../../../controllers/usersController";
import { Status } from "../../../constants/status";
import { Dropdown } from "../../../components/dropdown";
import { ReservationsController } from "../../../controllers/reservationsController";
import { useNavigate } from "react-router-dom";
import { useToastPromise } from "../../../components/toastPromise";

export const ReservationPreview = ({
  user,
  type,
  isOpen = false,
  handleClose,
  getAll,
  selectedData,
}) => {
  const navigate = useNavigate();
  const toastPromise = useToastPromise();
  const [inputs, setInputs] = useState({});
  const [loading, setLoading] = useState(true);
  const [userDetail, setUserDetail] = useState({});
  const initializeForm = useCallback(() => {
    if (selectedData) {
      const [startTime, endTime] = selectedData?.timeSlot
        ?.split("-")
        .map((time) => time.trim());
      setInputs({
        id: selectedData.id || "",
        reservationDate: selectedData.reservationDate || "",
        pax: selectedData.pax || "",
        userId: selectedData.userId || "",
        slotTitle: selectedData.slotTitle || "",
        startTime: startTime || "",
        endTime: endTime || "",
        status: selectedData.status || "",
        addOn: selectedData.addOn?.slotTitle || "No Add-On",
      });
    } else {
      setInputs({});
    }
  }, [selectedData]);
  const getUser = useCallback(async () => {
    if (!selectedData?.userId) return;
    try {
      const data = await new Promise((resolve, reject) => {
        UsersController.get({
          userId: selectedData.userId,
          resolve,
          reject,
        });
      });
      setUserDetail(data.data());
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  }, [selectedData]);
  const onHandleChange = (value, name) => {
    setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
  };
  const handleSubmit = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        ReservationsController.update({
          type: type,
          parameters: {
            id: inputs.id,
            status: inputs.status,
            lastModifiedBy: user.uid,
            lastModifiedDate: new Date().toLocaleString(),
          },
          resolve,
          reject,
        });
      }),
      successMessage: (data) => data,
      errorMessage: (data) => data,
      finishPromise: () => {
        getAll();
        setLoading(false);
        handleClose();
      },
      failPromise: () => {
        setLoading(false);
        navigate("/loginSignUp", { state: { isLoginToggle: true } });
      },
    });
  };
  useEffect(() => {
    if (isOpen) {
      initializeForm();
      getUser();
      setLoading(false);
    }
  }, [isOpen, initializeForm, getUser]);

  return (
    <PopupDialog
      name="reservationPreview"
      open={isOpen}
      onClose={() => {
        handleClose();
        initializeForm();
      }}
      title="Reservation Detail"
      negativeAction={<Button onClick={handleClose}>CLOSE</Button>}
      positiveAction={
        <Button
          onClick={handleSubmit}
          disabled={loading || selectedData?.status === inputs?.status}
        >
          {!loading ? "Submit" : "Submitting"}
        </Button>
      }
      content={
        <form onSubmit={handleSubmit}>
          <Textbox
            type="text"
            name="id"
            value={inputs?.id}
            placeholder="Reservation ID"
            readOnly
          />
          <Textbox
            type="text"
            name="reservationDate"
            value={inputs?.reservationDate}
            placeholder="Reservation Date"
            readOnly
          />
          <Textbox
            type="text"
            name="pax"
            value={inputs?.pax}
            placeholder="Pax"
            readOnly
          />
          <Textbox
            type="text"
            name="userId"
            value={inputs?.userId}
            placeholder="User ID"
            readOnly
          />
          <Textbox
            type="text"
            name="userName"
            value={`${userDetail?.firstName || ""} ${
              userDetail?.lastName || ""
            }`}
            placeholder="User Name"
            readOnly
          />
          <Textbox
            type="text"
            name="slotTitle"
            value={inputs?.slotTitle || ""}
            placeholder="Slot Title"
            readOnly
          />
          <Textbox
            type="text"
            name="startTime"
            value={inputs?.startTime || ""}
            placeholder="Start Time"
            readOnly
          />
          <Textbox
            type="text"
            name="endTime"
            value={inputs?.endTime || ""}
            placeholder="End Time"
            readOnly
          />
          <Dropdown
            name="status"
            title="Status"
            value={inputs?.status}
            options={Status.getReservationStatusList()}
            onChangeFunc={(value) => onHandleChange(value, "status")}
          />
          <Textbox
            type="text"
            name="addOn"
            value={inputs?.addOn || "No Add-On"}
            placeholder="Add-On"
            readOnly
          />
        </form>
      }
    />
  );
};
